/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* request body object
*/
export class RangedTerminalStatisticsValueRequest {
    'start': Date;
    'end': Date;
    /**
    * Statistic Name
    */
    'name': RangedTerminalStatisticsValueRequestNameEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "start",
            "baseName": "start",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "end",
            "baseName": "end",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "RangedTerminalStatisticsValueRequestNameEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return RangedTerminalStatisticsValueRequest.attributeTypeMap;
    }

    public constructor() {
    }
}


export type RangedTerminalStatisticsValueRequestNameEnum = "active_bookings" | "completed_bookings" | "canceled_bookings" | "time_register_success_transhipment" ;

